import { render, staticRenderFns } from "./TasksListTask.vue?vue&type=template&id=4ca5125f&"
import script from "./TasksListTask.vue?vue&type=script&lang=ts&"
export * from "./TasksListTask.vue?vue&type=script&lang=ts&"
import style0 from "./TasksListTask.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports